import { Dictionary } from 'lodash';
import { Project } from 'api/project';
import { fullName } from 'utils/full-name';
import { sortByText } from 'utils/sort-by-text';
import { SchedulerResourceType } from '../resource-types';
import { projectDateSorter, projectNameSorter } from '../utils/resource-tree';

export const getProjectsSorter = (projectLookup: Dictionary<Project>) => ({
  fn: (recordA, recordB) => {
    if (
      recordA.get('type') === SchedulerResourceType.Project &&
      recordB.get('type') === SchedulerResourceType.Project
    ) {
      const projectA = projectLookup[recordA.get('projectId')];
      const projectB = projectLookup[recordB.get('projectId')];
      const sortOrderByName = projectNameSorter(
        {
          projectName: recordA.get('projectName'),
        },
        {
          projectName: recordB.get('projectName'),
        },
      );

      if (projectA.startDate == null && projectB.startDate == null) {
        return sortOrderByName;
      }

      return (
        projectDateSorter(
          {
            startDate: projectA.startDate,
          },
          {
            startDate: projectB.startDate,
          },
        ) || sortOrderByName
      );
    }

    if (
      recordA.get('type') === SchedulerResourceType.Role &&
      recordB.get('type') === SchedulerResourceType.Role
    ) {
      const roleNameA = recordA.get('roleName');
      const roleNameB = recordB.get('roleName');

      if (roleNameA == null) {
        return 1;
      }
      if (roleNameB == null) {
        return -1;
      }

      return sortByText(roleNameA, roleNameB);
    }
    if (recordA.get('type') === SchedulerResourceType.AssignUserOrPlaceholder) {
      return 1;
    }
    if (recordB.get('type') === SchedulerResourceType.AssignUserOrPlaceholder) {
      return -1;
    }
    if (
      (recordA.get('type') === SchedulerResourceType.User ||
        recordA.get('type') === SchedulerResourceType.Team) &&
      (recordB.get('type') === SchedulerResourceType.User ||
        recordB.get('type') === SchedulerResourceType.Team)
    ) {
      const nameA =
        recordA.get('type') === SchedulerResourceType.User
          ? fullName({
              firstName: recordA.get('firstName'),
              lastName: recordA.get('lastName'),
            })
          : recordA.get('teamName');
      const nameB =
        recordB.get('type') === SchedulerResourceType.User
          ? fullName({
              firstName: recordB.get('firstName'),
              lastName: recordB.get('lastName'),
            })
          : recordB.get('teamName');

      const userOrTeamNameSort = sortByText(nameA, nameB);

      const referenceTeamA = recordA.get('referenceTeam');
      const referenceTeamB = recordB.get('referenceTeam');

      if (userOrTeamNameSort === 0) {
        if (referenceTeamA) {
          if (referenceTeamB) {
            return sortByText(referenceTeamA.teamName, referenceTeamB.teamName);
          }
        }

        return referenceTeamA ? 1 : referenceTeamB ? -1 : userOrTeamNameSort;
      }

      return userOrTeamNameSort;
    }

    return 1;
  },
});
